"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InstallmentPlansResponse = exports.Installment = exports.InstallmentPlan = void 0;
var InstallmentPlan = /** @class */ (function () {
    function InstallmentPlan() {
        this.id = 0;
        this.name = '';
        this.installments = [];
    }
    return InstallmentPlan;
}());
exports.InstallmentPlan = InstallmentPlan;
var Installment = /** @class */ (function () {
    function Installment() {
        this.id = 0;
        this.name = '';
        this.dueOn = new Date();
    }
    return Installment;
}());
exports.Installment = Installment;
var InstallmentPlansResponse = /** @class */ (function () {
    function InstallmentPlansResponse() {
        this.isAllowed = false;
        this.isRequired = false;
        this.installmentPlans = [];
    }
    return InstallmentPlansResponse;
}());
exports.InstallmentPlansResponse = InstallmentPlansResponse;
